export const MKT_PROJECT_KEY = "heydealer_share_sample";
export const MKT_APPSFLYER_DEFAULT_PARAMS = { defaultTemplateID: "QbFw", defaultURLID: "sampleprice" };
